import { useState } from "react";
import { ConfirmModalMode } from "../../types/ConfirmModalMode";

export const useConfirmModal = () => {
  const [confirmModalMode, setConfirmModalMode] =
    useState<ConfirmModalMode | null>(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const closeModal = () => {
    setIsConfirmModalOpen(false);
    setConfirmModalMode(null);
  };

  return {
    confirmModalMode,
    setConfirmModalMode,
    closeModal,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
  };
};
